module.exports = __webpack_public_path__ + "static/media/cbok.1ad5dbe4.png";